/* eslint-disable filenames/match-regex */

import InAppNotificationService from '@/services/InAppNotification.js';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 mins

// Module-level polling registry. Kept outside Vuex state because timer
// handles are not a reactive concern.
const pollingRegistry = {
  timer: null,
};

const state = {
  list: [],
  companyId: null,
  isLoading: false,
};

const getters = {
  list(state) {
    return state.list;
  },

  isLoading(state) {
    return state.isLoading;
  },
};

const actions = {
  load(store) {
    const companyId = store.state.companyId;
    if (store.state.isLoading || !companyId) {
      return Promise.resolve();
    }

    store.commit('isLoading', true);

    return InAppNotificationService.getList(companyId)
      .then(items => {
        // Only apply if the active company has not changed in the meantime.
        if (store.state.companyId === companyId) {
          store.commit('setList', items);
        }

        return items;
      })
      .finally(() => {
        store.commit('isLoading', false);
      });
  },

  startPolling(store, companyId) {
    if (!companyId) {
      return store.dispatch('reset');
    }

    const isCompanyChange = store.state.companyId !== companyId;
    store.dispatch('stopPolling');
    store.commit('setCompanyId', companyId);

    if (isCompanyChange) {
      store.commit('setList', []);
    }

    const loadPromise = store.dispatch('load');
    pollingRegistry.timer = setInterval(
      () => store.dispatch('load'),
      POLL_INTERVAL_MS,
    );

    return loadPromise;
  },

  stopPolling() {
    if (pollingRegistry.timer !== null) {
      clearInterval(pollingRegistry.timer);
      pollingRegistry.timer = null;
    }
  },

  reset(store) {
    store.dispatch('stopPolling');
    store.commit('reset');
  },

  dismiss(store, item) {
    const companyId = store.state.companyId;
    if (!companyId) {
      return Promise.resolve();
    }

    const previous = store.state.list;
    store.commit('removeFromList', item.id);

    return InAppNotificationService.dismiss(companyId, item.id)
      .catch(err => {
        store.commit('setList', previous);
        throw err;
      });
  },
};

const mutations = {
  isLoading(state, value) {
    state.isLoading = value;
  },

  setList(state, list) {
    state.list = list;
  },

  removeFromList(state, id) {
    state.list = state.list.filter(n => n.id !== id);
  },

  setCompanyId(state, companyId) {
    state.companyId = companyId;
  },

  reset(state) {
    state.list = [];
    state.companyId = null;
    state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
